import { Alert, Button } from 'react-bootstrap';

/**
 * Step 4 — Validate (design read §3.4, §3.5). `POST /tenants/:id/validate` runs a FEMA handshake
 * with the stored slot. After a pass, a first credential is enabled and a replacement is swapped
 * in (rotate). A failure names the stage only.
 *
 * @param {{ upload: import('../../hooks/useCredentialUpload').CredentialUploadState }} props
 */
const ValidateStep = ({ upload }) => {
  const { stored, validation } = upload;
  if (!stored) return null;

  const replacement = stored.credential.slot === 'pending';
  const finishLabel = replacement
    ? 'Swap in the new certificate'
    : stored.tenant.enabled
      ? 'Finish'
      : 'Enable';

  return (
    <div>
      <p>
        The credential is stored (generation {stored.credential.generation}). Validate it with FEMA
        before {replacement ? 'you swap it in' : 'you enable it'}.
      </p>

      {validation?.state === 'passed' ? <Alert variant="success">Validation passed.</Alert> : null}
      {validation?.state === 'failed' ? (
        <Alert variant="danger">
          Validation failed. Stage: {validation.stage ?? 'not recorded'}.
        </Alert>
      ) : null}

      <div className="d-flex gap-2">
        {validation?.state !== 'passed' ? (
          <Button onClick={upload.validate} disabled={upload.busy}>
            Validate
          </Button>
        ) : (
          <Button onClick={upload.finish} disabled={upload.busy}>
            {finishLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ValidateStep;
